// extracted by mini-css-extract-plugin
module.exports = {"free-shop-card__btn":"styles_free-shop-card__btn__1plDo","free-shop-card__list":"styles_free-shop-card__list__Xx7AV"};